import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import Modal from '@deprecated-ui/common/Modal';
import BaseSlider from '@deprecated-ui/trading/Slider';
import BaseInputNumber from '@deprecated-ui/trading/InputNumber';
import color from '@deprecated-ui/_style/color';
import { formatNumber } from 'utils/number';

const ModalFormWrapper = styled.div`
  position: relative;
  width: 480px;
`;

const PreviewModalContainer = styled(Modal)`
  & .ant-modal-content {
    border-radius: 6px 6px 0 0;
  }
`;

const TransactionModalContainer = styled(Modal).attrs({
  width: 'auto',
  type: 'transparent',
  centered: true,
})`
  max-width: 100%;
  .ant-modal-close {
    top: 8px;
  }

  .ant-modal-close-icon {
    svg {
      width: 14px;
    }
  }
`;

const FormHeader = styled(Flex)`
  margin-bottom: 15px;

  &.has-border {
    border-bottom: 1px solid ${color.gainsboro};
    padding-bottom: 15px;
  }
`;

const FormItemWrapper = styled.div`
  position: relative;
`;

const Tag = styled(Flex)`
  align-self: stretch;
  align-items: center;
  border-radius: 2px;
  background: ${color.nightRider};
  color: ${color.light};
  padding: 0 8px;
  font-weight: bold;
  min-height: 25px;
`;

const FormWrapper = styled.div`
  padding: 20px;
  background: ${color.light};
  border-radius: 4px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const InputNumber = styled(BaseInputNumber).attrs({
  formatter: (value: string) => formatNumber(value.replace(/\D/g, ''), false),
  parser: (value: string) => value.replace(/[, ]+/g, '').trim(),
})`
  width: ${(props) => {
    // @ts-expect-error
    if (props.isForTriggerPrice) return '63px !important';
    return '100px !important';
  }};

  .ant-input-number-input {
    padding: 0px !important;
  }

  .ant-input-number-handler-wrap {
    width: 0px !important;
  }

  .ant-input-number-handler-up {
    border-left: 1px solid ${color.gainsboro};
    left: ${
      // @ts-expect-error
      ({ isForTriggerPrice }) => {
        if (isForTriggerPrice) return '-1px !important';
        return '0px !important';
      }
    };
  }

  .ant-input-number-handler-down {
    border-right: 1px solid ${color.gainsboro};
    left: ${
      // @ts-expect-error
      ({ isForTriggerPrice }) => {
        if (isForTriggerPrice) return '-91px !important';
        return '-130px !important';
      }
    };
  }
`;

const PreviewContainer = styled(Flex)`
  gap: 12px;
`;

const PreviewItem = styled(Flex).attrs({
  width: '100%',
  justify: 'space-between',
  align: 'center',
  py: '3px',
})`
  transition: all 0.3s ease;
  gap: 8px;
`;

const PreviewItemRow = styled(Flex).attrs({
  justify: 'center',
  align: 'center',
  gap: '4px',
})`
  > div {
    border-color: #f2f1fe;
    background-color: #f2f1fe;
    color: #8277f8;
    padding: 2px 6px;
    margin-right: 2px;
    display: flex;
    gap: 2px;
  }
`;

const InvestmentWrapper = styled(Flex).attrs({
  width: '100%',
  align: 'center',
  justify: 'center',
})``;

const InvestmentDetail = styled(Flex).attrs({
  direction: 'column',
  width: '100%',
})`
  padding: 6px 12px;
  border: 1px solid ${color.gainsboro};
  border-radius: 4px;
  gap: 4px;
`;

const FeeItem = styled(Flex).attrs({
  width: '100%',
  align: 'center',
  justify: 'space-between',
  py: '2px',
})`
  border-bottom: 1px solid #f5f6f7;
  &:hover {
    cursor: pointer;
    background: #f5f6f7;
  }
`;

const FormLabel = styled.div.attrs({ align: 'right', pr: '30px' })`
  width: 40%;
  text-align: right;
  padding-right: 30px;
`;

const Slider = styled(BaseSlider)`
  .ant-slider-track {
    background-color: ${color.sunsetorange} !important;
    height: 3px;
    top: 5px;
  }
`;

const FreezeLayer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  background: ${color.light}80;
  height: 92%;
  z-index: 100;
`;

const ButtonWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: -16px;
  width: 100%;
  transform: translateY(100%);
`;

const SwitchWrapper = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
  height: '40px',
})`
  border-top: 1px solid ${color.gainsboro};
  cursor: pointer;
  margin: ${(props) =>
      // @ts-expect-error
      props.isOverlimit ? '50px' : '25px'} -20px -10px;
`;

const OrderButton = styled(Button)`
  border-radius: 4px;
  height: 44px;

  background: ${({ disabled }) => {
    if (disabled) return '#616161 !important';
    return color.primary;
  }};
  color: ${({ disabled }) => {
    if (disabled) return `${color.lowgray}!important`;
    return color.light;
  }};
  border-color: ${({ disabled }) => {
    if (disabled) return '#616161 !important';
    return color.primary;
  }};

  &.ant-btn-secondary {
    background-color: ${color.sunsetOrange};
    border-color: ${color.sunsetOrange};
  }

  & p {
    font-size: 14px;
    font-weight: bold;
    line-height: 19px;
    color: inherit;
    text-align: inherit;
  }
`;

const ModalTab = styled.div.attrs((props: { isActive: boolean }) => ({
  isActive: props.isActive,
}))`
  cursor: pointer;
  height: 51px;
  width: 50%;
  border-radius: 3px 3px 0 0;
  background: ${({ isActive }) => (isActive ? color.light : color.component)};
  border-bottom: ${({ isActive }) =>
    !isActive && `1px solid ${color.gainsboro}`};

  :first-child {
    border-right: 1px solid ${color.gainsboro};
  }
`;

const ModalTabText = styled(Text).attrs({
  family: 'bold',
  size: '24px',
  height: '50px',
  align: 'center',
})``;

const ShareTradeButton = styled(Button)`
  padding: 0;
  color: #00ab6b;

  &:hover,
  &:focus,
  &:active {
    color: #00ab6b;
  }

  & .anticon {
    width: 20px;
    height: 20px;
    font-size: 20px;
  }
`;

const OrderPlacedConfirmWrapper = styled(Flex)`
  position: absolute;
  bottom: -16px;
  transform: translateY(100%);

  & > button {
    margin 0 8px;

    :first-child { 
      margin-left: 0;
    }

    :last-child { 
      margin-right: 0;
    }
  }
`;

export {
  ModalFormWrapper,
  PreviewModalContainer,
  TransactionModalContainer,
  FormHeader,
  FormItemWrapper,
  Tag,
  FormWrapper,
  PreviewContainer,
  PreviewItem,
  PreviewItemRow,
  InvestmentWrapper,
  InvestmentDetail,
  FeeItem,
  Slider,
  FormLabel,
  FreezeLayer,
  ButtonWrapper,
  SwitchWrapper,
  OrderButton,
  InputNumber,
  ModalTab,
  ModalTabText,
  OrderPlacedConfirmWrapper,
  ShareTradeButton,
};
